<div class="container mt-7 mb-7">

    <div class="card-feature grid lg:grid-cols-4   md:grid-cols-3  xl:grid-cols-4 gap-4 sm:grid-cols-2 sm:justify-center">

        <div class="loading-skeleton grid grid-cols-3" *ngIf="isLoading">
            <ngx-skeleton-loader count="1" [theme]="{
                                                                                  'border-radius': '5px',
                                                                                  height: '282px',
                                                                                  width:'224px',
                                                                                  'background-color': 'gray',
                                                                                  border: '1px solid white'
                                                                                }"></ngx-skeleton-loader>
        </div>

        <div class="loading-skeleton grid grid-cols-3" *ngIf="isLoading">
            <ngx-skeleton-loader count="1" [theme]="{
                                                                                'border-radius': '5px',
                                                                                height: '282px',
                                                                                width:'224px',
                                                                                'background-color': 'gray',
                                                                                border: '1px solid white'
                                                                              }"></ngx-skeleton-loader>
        </div>

        <div class="loading-skeleton grid grid-cols-3" *ngIf="isLoading">
            <ngx-skeleton-loader count="1" [theme]="{
                                                                              'border-radius': '5px',
                                                                              height: '282px',
                                                                              width:'224px',
                                                                              'background-color': 'gray',
                                                                              border: '1px solid white'
                                                                            }"></ngx-skeleton-loader>
        </div>

        <div class="loading-skeleton grid grid-cols-3" *ngIf="isLoading">
            <ngx-skeleton-loader count="1" [theme]="{
                                                                    'border-radius': '5px',
                                                                    height: '282px',
                                                                    width:'224px',
                                                                    'background-color': 'gray',
                                                                    border: '1px solid white'
                                                                  }"></ngx-skeleton-loader>
        </div>

        <div [routerLink]="['add-project']" *ngIf="!isLoading && role == 'admin'" class="card hover:bg-slate-500 cursor-pointer sm:grid-rows-2">
            <div class="card-image mt-3 sm:grid-cols-2">
                <div class="label">
                    <span class="label-text"></span>
                </div>
                <img class="rounded" src="../../../assets/nft/plusimage.png" alt=""/>
                <div class="title grid grid-rows-2 pl-4 pt-2 ">
                    <h4>Tambah Projects</h4>
                </div>
            </div>
        </div>

        <div class="card hover:bg-slate-500 cursor-pointer sm:grid-rows-2" *ngFor="let item of project" (click)="goTodetail(item.status, item._id)">
            <div class="card-image mt-3 sm:grid-cols-2" *ngIf="!isLoading">
                <span class="w-1 h1" (click)="edit(item._id)" *ngIf="role == 'admin'">
                    <img data-bs-toggle="tooltip" data-bs-placement="top" title="Edit Projects" style="width: 30px; float: right; margin-top: -35px; margin-left: 20px ;" src="../../../assets/nft/icons8-edit.svg" alt="">
                </span>
                <div class="label">
                    <span class="label-text">{{item.status}}</span>
                </div>
                <img class="rounded" src="{{item.imageLink}}" alt=""/>
                <div class="title grid grid-rows-2 pl-4 pt-2 ">
                    <span class="font-bold">{{item.name}}</span>
                    <br/>
                    <span [innerHTML]="item.description.length < 20 ? item.description : item.description | slice:0:20 " class="text-bold">
                        <span *ngIf="item.description.length > 20">.....</span>
                    </span>
                </div>
            </div>
        </div>

    </div>
    <div class="paginate">
        <button class="btn btn-primary float-right mt-3" *ngIf="page == 1 || page >= 1" (click)="doNavigate()">Next</button>
        <button class="btn btn-primary float-right mt-3" *ngIf="page == 2 || page >= 2" (click)="pervious()">Previous</button>
        <!-- <button class="btn btn-primary float-right mt-3">Back</button> -->
    </div>
</div>
